import { ComputedProperties } from '../../ReplicantComputedProperties';
import { localStorage as browserLocalStorage } from '@play-co/browser-storage';
import { getAllKeysFromLocalStorage, KEY_PREFIX } from '../../db/impl/LocalStorageDB';
import { IndexDB } from '../IndexDB';
import createIndexDBDev from './IndexDBDev';

export default function createIndexDBLocalStorage<TComputedProperties extends ComputedProperties>(
    indexName: string,
    computedProps: TComputedProperties,
    opts?: {
        prefix?: string;
        storage?: Storage;
    },
): IndexDB<TComputedProperties> {
    const prefix = KEY_PREFIX + (opts?.prefix ? '_' + opts.prefix : '') + '_index_';
    const localStorage = opts?.storage ?? browserLocalStorage;

    function getAllIds(index: string) {
        const keys = getAllKeysFromLocalStorage(localStorage);
        const prefixForIndex = prefix + index + '_';
        const ids = keys.filter((x) => x.startsWith(prefixForIndex)).map((x) => x.slice(prefixForIndex.length));
        return ids;
    }

    return createIndexDBDev(indexName, computedProps, {
        pushToIndex: (index, id, doc) => {
            localStorage.setItem(prefix + index + '_' + id, JSON.stringify(doc));
        },

        getAllIds: (index) => getAllIds(index),

        getFromIndex: (index, id) => {
            const item = localStorage.getItem(prefix + index + '_' + id);
            return item ? JSON.parse(item) : null;
        },

        reset: () => {
            const ids = getAllIds(indexName);
            ids.forEach((id) => localStorage.removeItem(prefix + indexName + '_' + id));
        },

        deleteFromIndex: (index, id) => {
            localStorage.removeItem(prefix + index + '_' + id);
        },
    });
}
